import React, { useEffect, useState } from "react";
import { Switch, Pagination, message } from "antd";
import { DownOutlined, NodeExpandOutlined } from "@ant-design/icons";
import "./index.scss";
import carbonImg from "./images/carbon.png";
import { stationApi } from "@api/newApi";
import { connect } from "react-redux";
import TimeSharingControlModal from "../../../components/TimeSharingControlModal";
import Chart from "../components/Chart";

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(() => {
  const [aicontrol, setAicontrol] = useState(true);
  const [aicontrol1, setAicontrol1] = useState(false);
  const [show, setShow] = useState(false);
  const [dataInfo, setDataInfo] = useState({});
  const [chartData, setChartData] = useState([]);
  const [settValue, setSettValue] = useState({
    tydl: 0,
    tdb: 0,
    tymd: 0,
    tynd: 0,
  });

  useEffect(() => {
    getChartData();
    getData();
  }, []);

  const getData = () => {
    stationApi.carbonSource().then((res) => {
      if (res.status !== "0") return;
      const { tydl, tdb, tymd, tynd } = res.data;
      setDataInfo(res.data);
      setSettValue({
        tydl: tydl ? tydl * 1 : 0,
        tdb: tdb ? tdb * 1 : 0,
        tymd: tymd ? tymd * 1 : 0,
        tynd: tynd ? tynd * 1 : 0,
      });
    });
  };

  const changeValue = (e, key) => {
    setSettValue({ ...settValue, [key]: e.target.value * 1 });
  };

  const setParams = () => {
    stationApi.carbonSourceSetParams(settValue).then((res) => {
      if (res.status !== "0") return;
      message.success("设置成功");
      getData();
    });
  };

  const showModal = () => {
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
  };

  const onChange = () => {};

  const getChartData = async () => {
    stationApi.getCarbonIntellectAnalyzeChart().then((res) => {
      if (res.status !== "0") return;
      setChartData(res.data);
    });
  };

  return (
    <div className="carbon">
      <div className="carbon-controlls">
        <div className="dosing-switch">
          <div className="text">AI控制</div>
          <Switch checked={aicontrol} onChange={(e) => setAicontrol(e)} />
        </div>
        <div className="time-sharing-control">
          <div
            className="tsc-text"
            onClick={showModal}
            style={{ borderRadius: 5 }}
          >
            分时控制
            <NodeExpandOutlined />
          </div>
        </div>
      </div>
      <div className="dosing-process">
        <div className="bg">
          <img src={carbonImg} />
        </div>

        <div className="setting-params">
          <div className="setting-item">
            <div className="setting-item-title">碳源当量:</div>
            <div className="setting-item-input">
              <input
                type="number"
                placeholder="请输入碳源当量"
                value={settValue.tydl}
                onChange={(e) => changeValue(e, "tydl")}
                onBlur={setParams}
              />
            </div>
            <div className="setting-item-unit">COD/g</div>
          </div>
          <div className="setting-item">
            <div className="setting-item-title">碳氮比设定:</div>
            <div className="setting-item-input">
              <input
                type="number"
                placeholder="请输入碳氮比设定"
                value={settValue.tdb}
                onChange={(e) => changeValue(e, "tdb")}
                onBlur={setParams}
              />
            </div>
          </div>
          <div className="setting-item">
            <div className="setting-item-title">碳源密度:</div>
            <div className="setting-item-input">
              <input
                type="number"
                placeholder="请输入碳源密度"
                value={settValue.tymd}
                onChange={(e) => changeValue(e, "tymd")}
                onBlur={setParams}
              />
            </div>
            <div className="setting-item-unit">kg/L</div>
          </div>
          <div className="setting-item">
            <div className="setting-item-title">碳源浓度:</div>
            <div className="setting-item-input">
              <input
                type="number"
                placeholder="请输入碳源浓度"
                value={settValue.tynd}
                onChange={(e) => changeValue(e, "tynd")}
                onBlur={setParams}
              />
            </div>
          </div>
        </div>

        <div className="dosing-devices">
          <div className="dosing-d dosing-d-1">乙酸钠储罐</div>
          <div className="dosing-d dosing-d-2">乙酸钠储罐</div>
        </div>
        <div className="device-style1" style={{ left: 346, top: -26 }}>
          AI智能投加系统
        </div>
        <div style={{ position: "absolute", left: 56, top: -14 }}>
          <div
            className="device-style3 device-style3-nhover"
            style={{ position: "relative", marginBottom: 10 }}
          >
            <div className="bd">
              <div className="data-item">
                碳源体积投加量：
                <span className="val">{dataInfo.tyTjTjl}</span>
                <span className="unit">L/d</span>
              </div>
            </div>
          </div>
          <div
            className="device-style3 device-style3-nhover"
            style={{ position: "relative", marginBottom: 10 }}
          >
            <div className="bd">
              <div className="data-item">
                外加碳源投加量：
                <span className="val">{dataInfo.wjTyTjl}</span>
                <span className="unit">kg/d</span>
              </div>
            </div>
          </div>
          <div
            className="device-style3 device-style3-nhover"
            style={{ position: "relative", marginBottom: 10 }}
          >
            <div className="bd">
              <div className="data-item">
                外加碳源需求量：
                <span className="val">{dataInfo.wjTyXql}</span>
                <span className="unit"></span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            className="device-style3"
            style={{ zIndex: 99, top: 80, left: 476 }}
          >
            <div className="bd">
              <div className="data-item">
                储罐1液位： <span className="val">{dataInfo.cg1yw}</span>
                <span className="unit">m</span>
              </div>
              <div className="data-item">
                储罐2液位： <span className="val">{dataInfo.cg2yw}</span>
                <span className="unit">m</span>
              </div>
            </div>
            <div className="dosing-data-ft">
              <DownOutlined />
            </div>
          </div>
          <div className="device-style4" style={{ right: 727, top: 58 }}>
            <div className="device-s4-hd">1#生化池流量2</div>
            <div className="device-s4-bd">
              <div className="device-s4-item">
                <span className="name">瞬时：</span>
                <span className="val">{dataInfo.shc1ssll2}</span>
                <span className="unit">m³/h</span>
              </div>
              <div className="device-s4-item">
                <span className="name">累计：</span>
                <span className="val">{dataInfo.shc1ljll2}</span>
                <span className="unit">m³</span>
              </div>
            </div>
          </div>
          <div className="device-style4" style={{ right: 727, top: 176 }}>
            <div className="device-s4-hd">2#生化池流量1</div>
            <div className="device-s4-bd">
              <div className="device-s4-item">
                <span className="name">瞬时：</span>
                <span className="val">{dataInfo.shc2ssll1}</span>
                <span className="unit">m³/h</span>
              </div>
              <div className="device-s4-item">
                <span className="name">累计：</span>
                <span className="val">{dataInfo.shc2ljll1}</span>
                <span className="unit">m³</span>
              </div>
            </div>
          </div>
          <div className="device-style4" style={{ right: 456, top: 470 }}>
            <div className="device-s4-hd">进水硝态氮</div>
            <div className="device-s4-bd">
              <div className="device-s4-item">
                <span className="name">实际值：</span>
                <span className="val">{dataInfo.jsXtd}</span>
                <span className="unit">mg/L</span>
              </div>
            </div>
          </div>
          <div className="device-style5" style={{ left: 0, bottom: 209 }}>
            <div className="device-s5-item">
              <span className="name">进水COD：</span>
              <span className="val">{dataInfo.jsCod}</span>
              <span className="unit"></span>
            </div>
            <div className="device-s5-item">
              <span className="name">进水TN：</span>
              <span className="val">{dataInfo.jsTn}</span>
              <span className="unit"></span>
            </div>
            <div className="device-s5-item">
              <span className="name">进水水温：</span>
              <span className="val">{dataInfo.jsSw}</span>
              <span className="unit"></span>
            </div>
            <div className="device-s5-item">
              <span className="name">进水累计流量：</span>
              <span className="val">{dataInfo.jsLjll}</span>
              <span className="unit">m³</span>
            </div>
            <div className="device-s5-item">
              <span className="name">进水瞬时流量：</span>
              <span className="val">{dataInfo.jsSsll}</span>
              <span className="unit">m³/h</span>
            </div>
            <div className="device-s5-item">
              <span className="name">进水天流量：</span>
              <span className="val">{dataInfo.jsDayLl}</span>
              <span className="unit">m³</span>
            </div>
          </div>
          <div className="device-style5" style={{ right: 0, bottom: 208 }}>
            <div className="device-s5-item">
              <span className="name">出水COD：</span>
              <span className="val">{dataInfo.csCod}</span>
              <span className="unit"></span>
            </div>
            <div className="device-s5-item">
              <span className="name">出水TN：</span>
              <span className="val">{dataInfo.csTn}</span>
              <span className="unit"></span>
            </div>
            <div className="device-s5-item">
              <span className="name">出水氨氮：</span>
              <span className="val">{dataInfo.csAd}</span>
              <span className="unit"></span>
            </div>
          </div>
          <div className="device-style6" style={{ bottom: 225, left: 415 }}>
            1#生化池 投加量：{dataInfo.shc1tjl}mg/L
          </div>
          <div className="device-style6" style={{ bottom: 303, left: 415 }}>
            2#生化池 投加量：{dataInfo.shc2tjl}mg/L
          </div>
          <div
            className="device-style7"
            style={{ top: 145, left: 476, zIndex: 98 }}
          >
            <div className="bd" style={{ height: 120 }}>
              <div className="data-item">
                <span
                  className={dataInfo.ysnJyb1 == 1 ? "cr succes" : "cr"}
                ></span>
                <span>
                  <em>1#</em>乙酸钠加药泵
                </span>
              </div>
              <div className="data-item">
                <span
                  className={dataInfo.ysnJyb2 == 1 ? "cr succes" : "cr"}
                ></span>
                <span>
                  <em>2#</em>乙酸钠加药泵
                </span>
              </div>
            </div>
          </div>
          <div
            className="device-style7"
            style={{ bottom: 569, right: 206, zIndex: 98 }}
          >
            <div className="bd">
              <div className="data-item">
                <span
                  className={dataInfo.ysnJyb3 == 1 ? "cr succes" : "cr"}
                ></span>
                <span>
                  <em>3#</em>乙酸钠加药泵
                </span>
              </div>
            </div>
          </div>
          <div className="device-style4" style={{ right: 17, bottom: 525 }}>
            <div className="device-s4-hd">乙酸钠反硝化流量</div>
            <div className="device-s4-bd">
              <div className="device-s4-item">
                <span className="name"></span>
                <span className="val">{dataInfo.ysnfxhll}</span>
                <span className="unit">m³/h</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dosing-chart-ai">
        <div className="dosing-chart">
          <Chart
            chartTitle="智能碳源分析"
            chartData={chartData}
            id="carbonChart"
            width="100%"
            height="100%"
          />
        </div>
        <div className="dosing-ai">
          <div className="dosing-switch">
            <div className="text">AI窗口会话</div>
            <Switch checked={aicontrol1} onChange={(e) => setAicontrol1(e)} />
          </div>
          <div className="dosing-ai-list">
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
            <div className="dosing-ai-item">
              <div className="dosing-ai-item-time">2024-08-28 15:00:00</div>
              <div className="dosing-ai-item-val">
                混凝沉淀池实际投加药剂量 948.67 kg
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dosing-report">
        <div className="dosing-report-title">智能除磷分析报告</div>
        <div className="dosing-report-content">
          <div className="dosing-report-head">
            <div>生成时间</div>
            <div>报告名称</div>
            <div>报告摘要</div>
            <div>操作</div>
          </div>
          <div className="dosing-report-body">
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
            <div className="dosing-report-item">
              <div>2023-03-30 08:30:00</div>
              <div>智能除磷分析报告230330</div>
              <div>节省药剂3.0%</div>
              <div>
                <span>预览</span>
              </div>
            </div>
          </div>

          <div className="dosing-report-pages">
            <Pagination
              showQuickJumper
              defaultCurrent={1}
              total={100}
              onChange={onChange}
              showTotal={(total) => `总共${total}条`}
            />
          </div>
        </div>
      </div>
      {show && (
        <TimeSharingControlModal
          visible={show}
          onCancel={closeModal}
          controllType={1}
        />
      )}
    </div>
  );
});
